import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ImportChannel } from 'src/app/services/import-channels/import-channel.model';
import { FinBankConnectionsService } from 'src/app/services/fin-api/fin-bank-connections.service';
import { environment } from 'src/environments/environment';
import platform from 'platform';
import { Socket } from 'ngx-socket-io';
import { Subject, takeUntil } from 'rxjs';
import { FinTaskDto } from 'src/app/services/fin-api/dto/fin-task.dto';
import { DonationsService } from 'src/app/services/donations.service';
import dayjs from 'dayjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-import-donations',
    templateUrl: './dialog-import-donations.component.html',
    styleUrls: ['./dialog-import-donations.component.scss'],
})
export class DialogImportDonationsComponent implements OnInit, OnDestroy {
    status: Map<string, number> = new Map();

    today = dayjs().format('DD.MM.YYYY');
    activeRequest?: string;
    imported = false;

    private readonly destroy = new Subject<void>();

    constructor(
        private readonly finBankConnectionsService: FinBankConnectionsService,
        private readonly donationsService: DonationsService,
        public readonly dialogRef: MatDialogRef<DialogImportDonationsComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: { channels: ImportChannel[] },
        private readonly socket: Socket,
    ) {}

    ngOnInit(): void {
        this.socket
            .fromEvent<FinTaskDto>('fin-webform')
            .pipe(takeUntil(this.destroy))
            .subscribe((res: FinTaskDto) => {
                if (res.status === 'WEB_FORM_REQUIRED' && res.webForm && this.activeRequest) {
                    window.location.href = res.webForm.url + `?redirectUrl=${environment.url}`;
                }
            });

        this.socket
            .fromEvent<FinTaskDto & { amount: number }>('fin')
            .pipe(takeUntil(this.destroy))
            .subscribe((res) => {
                if (res.status === 'COMPLETED') {
                    this.imported = true;
                    if (this.activeRequest) {
                        this.status.set(this.activeRequest, res.amount);
                    }
                    this.activeRequest = undefined;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy.next();
        this.destroy.complete();
    }

    onSubmitAltruja(id: string): void {
        if (this.activeRequest) {
            return;
        }
        this.activeRequest = id;

        this.donationsService.importAltruja(id).subscribe(
            (res: { count: number }) => {
                this.imported = true;
                this.activeRequest = undefined;
                this.status.set(id, res.count);
            },
            () => {
                this.activeRequest = undefined;
                this.status.set(id, -1);
            },
        );
    }

    onSubmitFin(id: string, connectionId: number): void {
        if (this.activeRequest) {
            return;
        }

        this.activeRequest = id;

        this.finBankConnectionsService
            .update({
                bankConnectionId: connectionId,
                os: platform.os?.toString() ?? '',
            })
            .subscribe(
                () => {
                    // success
                },
                () => {
                    this.activeRequest = undefined;
                    this.status.set(id, -1);
                },
            );
    }
}
